module.exports = __webpack_public_path__ + "static/free-6e0f7a073176d5bdbb1593a6e9cbdca7.png";